module.exports = __webpack_public_path__ + "img/dodExitBtn.350acc01.svg";